<div class="grid-container">
  <form [formGroup]="form">
    <div>
      <div class="cell small-4 medium-4 large-4 padding-right">
        <div>
          <div class="cell small-4 medium-4 large-4 bold">
            Well API:
          </div>
          <div class="cell small-8 medium-8 large-8">
            <input type="text" formControlName="apiNumber" />
          </div>
          <div class="cell small-12 medium-12 large-12 red italic">
            @if (invalidAPI == true) {
              <small>If provided, API # must be 14 characters long.</small>
            }
          </div>
          <div class="cell small-4 medium-4 large-4 bold">
            County:
          </div>
          <div class="cell small-8 medium-8 large-8">
            <select id="county" formControlName="county">
              @for (c of countyObservable | async; track c) {
                <option [ngValue]="c">{{c}}</option>
              }
            </select>
          </div>
          <div class="cell small-4 medium-4 large-4 bold">
            Township:
          </div>
          <div class="cell small-8 medium-8 large-8">
            <select id="township" formControlName="township">
              @for (t of townshipObservable | async; track t) {
                <option [ngValue]="t">{{t}}</option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="cell small-6 medium-6 large-6">
        <div class="cell small-12 medium-12 large-12">
          <div class="cell small-3 medium-3 large-3">
            <button class="button" (click)="searchWells()" [disabled]="disableSearch  || searchActive || (invalidCounty && invalidTownship)">Search By County/Township</button>
            <text-loader [run]="disableSearch" [interval]="1000" [text]="'Populating county/township options'"></text-loader>
          </div>
          <div class="cell small-3 medium-3 large-3">
            <button class="button" (click)="searchWells()" [disabled]="searchActive || invalidAPI">Search By API</button>
          </div>
        </div>

        <div class="cell small-12 medium-12 large-12 red italic">
          @if (invalid == true) {
            <small>One of API #, County, or Township must be selected to run the search.</small>
          }
          <text-loader [run]="searchActive" [interval]="1000" [text]="'Searching'"></text-loader>
        </div>
      </div>
    </div>
  </form>
  @if (wellSearched) {
    <div>
      <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="results" aria-label="Delete Api"></ag-grid-angular>
    </div>
  }
</div>
